export default __webpack_public_path__ + "static/media/allStripePaymentIcon.3dde0e38.svg";